import { create } from "zustand";
import { getFailedUniOrders, postFailedUniOrders } from "../api";

export const useFailedUniOrders = create((set) => ({
  failedUniData: {},
  validateLoading: false,
  isError: false,
  errorMessage: "",
  getValidateData: async (page) => {
    try {
      set({ validateLoading: true, error: null });
      const response = await getFailedUniOrders(page);
      set({ failedUniData: response.data, validateLoading: false });
    } catch (error) {
      set({ error: error.message });
    } finally {
      set({ validateLoading: false });
    }
  },
  postFailedData: async (payload)=>{
    try {
      set({ validateLoading: true, error: null });
      await postFailedUniOrders(payload);
    } catch (error) {
      set({ error: error.message });
    } finally {
      set({ validateLoading: false });
    }
  }
}));
